import * as tslib_1 from "tslib";
import getMobileDeviceStatisticsOperation from 'owa-service/lib/operation/getMobileDeviceStatisticsOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
export function getMobileDeviceStatistics() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var request, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        Header: getJsonRequestHeader(),
                        Options: {
                            GetMailboxLog: false,
                        },
                    };
                    return [4 /*yield*/, getMobileDeviceStatisticsOperation(request)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
            }
        });
    });
}
//# sourceMappingURL=getMobileDeviceStatistics.js.map